import React from 'react';
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
} from 'react-share';
import { SwaggerApi } from '@/pages/ApiDoc/swagger-ui';

interface SocialSharingProps {
  api: SwaggerApi | { linkId?: string; summary: string };
}

const SocialSharing: React.FC<SocialSharingProps> = ({ api }) => {
  const hash = api.linkId ? `#${encodeURIComponent(api.linkId)}` : '';
  const url = `${window.location.origin}${window.location.pathname}${hash}`;
  const subject = api.summary;

  return (
    <div className="shareContainer">
      <EmailShareButton className="shareIcon" url={url} subject={subject}>
        <EmailIcon size={32} round />
      </EmailShareButton>
      <FacebookShareButton className="shareIcon" url={url}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton className="shareIcon" url={url}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <LinkedinShareButton className="shareIcon" url={url}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
    </div>
  );
};

export default SocialSharing;
